(() => {
  'use strict';

  if (customElements.get('pt-skin-surface')) return;

  class SkinSurface extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.object = this.querySelector('.pt-skin-surface__object');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!this.object) return;

      const options = { signal: this.abort.signal };
      this.addEventListener('pointermove', (event) => this.tilt(event), options);
      this.addEventListener('pointerleave', () => this.reset(), options);
    }

    disconnectedCallback() {
      this.abort?.abort();
    }

    tilt(event) {
      if (this.reducedMotion.matches || event.pointerType === 'touch') return;

      const bounds = this.getBoundingClientRect();
      const x = (event.clientX - bounds.left) / bounds.width - 0.5;
      const y = (event.clientY - bounds.top) / bounds.height - 0.5;

      this.object.style.setProperty('--pt-skin-rx', `${(-y * 7).toFixed(2)}deg`);
      this.object.style.setProperty('--pt-skin-ry', `${(x * 7).toFixed(2)}deg`);
    }

    reset() {
      this.object.style.removeProperty('--pt-skin-rx');
      this.object.style.removeProperty('--pt-skin-ry');
    }
  }

  customElements.define('pt-skin-surface', SkinSurface);
})();
